"use client";

import React from "react";
import Image from "next/image";
import "./ProjectHighlightsSection.css";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
export default function ProjectHighlightsSection({ projectDetail }) {
  if (!projectDetail) return null;

  const highlightImages = {
    880: "/highlight-banners/palm.jpg",

    881: "/highlight-banners/sarvam.jpg",

    887: "/highlight-banners/parva.jpg",

    888: "/highlight-banners/stark-torre.jpg",

    default: "/images/nb-palm/palm-highlights-banner.jpg",
  };

  const highlightImage =
    highlightImages[String(projectDetail?.project_id)] ||
    highlightImages.default;

  const { scrollYProgress } = useScroll();

  const imageY = useTransform(scrollYProgress, [0, 1], [-120, 120]);

  const smoothY = useSpring(imageY, {
    stiffness: 40,
    damping: 20,
    mass: 1,
  });

  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="project-highlights-section section-padding">
      <div className="main-container-fluid">
        <div className="project-highlight-grid">
          {/* LEFT IMAGE */}

          <div className="project-highlight-image">
            <div className="highlight-image-wrapper">
              <motion.div
                className="w100 h100"
                // style={{ y: smoothY }}
                variants={scaleFadeVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
              >
                <Image
                  src={highlightImage}
                  alt={projectDetail.project_title}
                  fill
                  priority
                  className="object-cover"
                  sizes="
      (max-width:991px)
      100vw,
      50vw
    "
                />
              </motion.div>
            </div>
          </div>

          {/* RIGHT CONTENT */}

          <div className="project-highlight-content">
            {projectDetail?.highlights?.map((item, index) => (
              <div
                className="
                  highlight-item
                  "
                key={index}
              >
                <h3>{item.tag_line}</h3>

                <p>{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
